export default "__VITE_ASSET__BZq81WcD__"